// src/App.js
import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import styled from "styled-components";

import { theme } from "./Theme";
import { GlobalStyle } from "./GlobalStyle";
import ScrollToTop from "./ScrollToTop";

import Header from "./components/Header";
import HeroBanner from "./components/HeroBanner";
import ConsultancySection from "./components/ConsultancySection";
import Section from "./components/Section";
import About from "./components/About";
import BackToTop from "./components/BackToTop";
import Footer from "./components/Footer";
import Projects from "./components/Projects";
import ContactUs from "./components/ContactUs";
import ContentShowcase from "./components/ContentShowcase";
import ContactMini from "./components/ContactMini";
import AboutUs from "./components/AboutUs";
import Privacy from "./components/Privacy";
import Webprojects from "./components/Webprojects";

const AppContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

const App = () => {
  const experienceRef = useRef(null);
  const educationRef = useRef(null);
  const aboutUsRef = useRef(null);
  const ProfessionalCertificationsRef = useRef(null);
  const ConsultancySectionRef = useRef(null);
  const SectionRef = useRef(null);
  const AboutRef = useRef(null);
  const ContactUsRef = useRef(null);
  const ContactMiniRef = useRef(null);
  const WebprojectsRef = useRef(null);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <ScrollToTop /> {/* Scrolls to top on every route change */}
        <Header
          experienceRef={experienceRef}
          educationRef={educationRef}
          aboutUsRef={aboutUsRef}
          ProfessionalCertificationsRef={ProfessionalCertificationsRef}
          ConsultancySectionRef={ConsultancySectionRef}
          SectionRef={SectionRef}
          AboutRef={AboutRef}
          ContactMiniRef={ContactMiniRef}
          ContactUsRef={ContactUsRef}
        />
        <Routes>
          <Route
            path="/"
            element={
              <AppContainer>
                <HeroBanner aboutUsRef={aboutUsRef} />
                <div ref={ConsultancySectionRef}>
                  <ConsultancySection />
                </div>
                <div ref={SectionRef}>
                  <Section />
                </div>
                <div ref={AboutRef}>
                  <About />
                </div>
                <div ref={AboutRef}>
                  <ContactMini />
                </div>
                {/* Uncomment below if you want ContactUs in HomePage */}
                {/* <div ref={ContactUsRef}>
                  <ContactUs />
                </div> */}
                {/* <div ref={WebprojectsRef}>
                  <Webprojects />
                </div> */}
                <ContentShowcase />
                <BackToTop />
              </AppContainer>
            }
          />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;
